var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._g(_vm._b({staticClass:"obi-form",class:{ 'obi-form--loading': _vm.loading },attrs:{"autocomplete":"off"}},'form',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }